export default __webpack_public_path__ + "src/images/galleries/0/entry-9e4500.png";